<app-da-vinci-app *ngIf="item.type === 'DaVinciApp'" [plugin]="item.params"></app-da-vinci-app>
<app-constant-size *ngIf="item.type === 'ConstantSize'" [params]="item.params"></app-constant-size>
<app-tabbed-items *ngIf="item.type === 'TabbedItems'" [plugins]="item.params"></app-tabbed-items>
